import styled from "styled-components";

export const MainContainer = styled.div`
  border-left: 1px solid #dfe3e8;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    border-left: none;
  }
`;

export const InnerContainer = styled.div`
  padding-left: 60px;
  @media (max-width: 768px) {
    padding-left: 0px;
  }
`;

export const Header = styled.h1`
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-transform: capitalize;
`;

export const ConnectedStoresSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const ConnectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #333;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;
